import { atom } from "jotai";

export const internalSurveyState = atom<boolean>(false);